import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import type { NotesReactionsService, ReactionData } from '@core/reactions-legacy';
import type { Reactions } from '@core/reactions-types';
// eslint-disable-next-line boundaries/element-types
import { type EmojiItem, SYMBOL_EMOJI_MAP } from '@core/symbol-data';

@Injectable({ providedIn: 'root' })
export class TellentNotesReactionsService implements NotesReactionsService {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public createReaction(noteId: number, unicode: string): void {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public deleteReaction(noteId: number, unicode: string): void {}

  public flattenReactions(reactions: Reactions): Observable<ReactionData[]> {
    return of([]);
  }

  public getEmojiShortName(symbol: string): string {
    return (<EmojiItem>SYMBOL_EMOJI_MAP[symbol])?.shortName || '';
  }
}
